import type {Schedule} from '@domain/schedule'
import {useCurrentScheduleQuery} from '@domain/schedule'
import {useUpmPlantContext} from '@hconnect/upm'

import type {MomentRange} from '../../../types'
import {usePeriodicAutofillCheck} from '../../usePeriodicAutofillCheck'

interface ScheduleQueryParams {
  isDisabled?: boolean
  range: MomentRange
}

const countScheduleItemsSelector = (data: Schedule) => Object.values(data?.schedules ?? {}).length

export const useCountScheduleItemsQuery = ({isDisabled = false, range}: ScheduleQueryParams) => {
  const {plantId: plantCode} = useUpmPlantContext()

  // schedule is reloaded if there is a change in the autofill status
  usePeriodicAutofillCheck()

  return useCurrentScheduleQuery<number>({
    plantId: plantCode,
    range,
    enabled: !isDisabled,
    select: countScheduleItemsSelector
  })
}
